import { render } from "./EditableParagraph.vue?vue&type=template&id=fe5a7d3c"
import script from "./EditableParagraph.vue?vue&type=script&lang=js"
export * from "./EditableParagraph.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__